/* eslint-disable react/prop-types */
import styled from 'styled-components';
import ds, { media } from 'designsystem';
import Container from 'blocks/Container/Container';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FiltersList from 'blocks/FiltersList';
import ANCHOR from 'common/consts/anchor';
import { underscoresToDashes } from 'common/methods/string';
import Paragraph from 'elements/Paragraph';
import { limitArticleChars } from 'common/methods/blogMethods';
import { BlogArticle as BlogArticleModel } from 'models';
import Header3 from 'elements/Header3';
import Fade from 'react-reveal/Fade';
import { FADE_VALUES, parallaxImage } from 'animations/Animations';
import { Bind } from 'lodash-decorators';
import { BLOG_SETTINGS } from 'common/consts/blog';
import FullWidthImage from './FullWidthImage';
import MobileImage from './MobileImage';
import Wrapper from './Wrapper';
import Link from 'blocks/StyledLink';

const LatestArticleWrapper = styled.div`
  margin-bottom: ${ds.get('metrics.l')};
  position: relative;
`;

const RelativeContainer = styled(Container)`
  position:relative;
  height: 100%;
`;

const RelativeImageBox = styled.div`
  position: relative;
  overflow: hidden;
  
  ${media.desktop`
    height: 500px;
  `};
`;

const StyledHeader3 = styled(Header3)`
  margin-top: ${ds.get('metrics.m')};
  padding: 0 ${ds.get('metrics.s')};
  
  ${media.desktop`
    padding-left: initial;
    margin-top: ${ds.get('metrics.xxl')};
  `};
`;

const StyledParagraph = styled(Paragraph)`
  padding: 0 ${ds.get('metrics.s')};
  
  ${media.desktop`
    padding-left: initial;
  `}
`;

const FiltersListWrapper = styled.div`
  padding: 0 ${ds.get('metrics.s')};
  ${media.desktop`
    padding-left: initial;
  `}
`;

const LatestArticleWithFilter = styled.div``;

@inject('coreStore', 'blogStore', 'windowStore', 'appStore')
@observer
class LatestArticle extends Component {
  constructor(props) {
    super(props);
    this.fullWidthImageRef = React.createRef();
  }

  componentDidMount() {
    const { windowStore } = this.props;
    this.disposeOnScroll = windowStore.reactToScroll(this.onScroll, { fireImmediately: true });
    setTimeout(() => {
      this.onScroll();
    }, 0);
  }

  componentWillUnmount() {
    this.disposeOnScroll();
  }

  @Bind
  onScroll() {
    const { windowStore: { isOnMobile } } = this.props;

    if (!isOnMobile && this.fullWidthImageRef.current) {
      parallaxImage(this.fullWidthImageRef.current, 200, -150, 6);
    }
  }


  render() {
    const {
      backgroundImage,
      article: {
        title,
        content,
        slug,
        articleAuthor,
        mainCategory: {
          codename,
        },
      },
      onSelect,
      coreStore,
      blogStore,
      windowStore: {
        isOnTablet,
        isOnMobile,
      },
      appStore: {
        currentLanguage,
      },
    } = this.props;

    const articleCategory = underscoresToDashes(codename);

    return (
      <LatestArticleWrapper>
        <RelativeContainer>
          <Wrapper>
            <Fade bottom distance={`${FADE_VALUES.BOX.LIGHT}`}>
              <LatestArticleWithFilter>
                <FiltersListWrapper>
                  <FiltersList
                    categories={blogStore.categoriesToRender}
                    onSelect={onSelect}
                    activeFilter={blogStore.blogState.activeCategory}
                  />
                </FiltersListWrapper>
                <Link to={`${ANCHOR.BLOG[currentLanguage]}/${articleCategory}/${slug}`}>
                  <StyledHeader3>
                    {title}
                  </StyledHeader3>

                  {isOnTablet && <MobileImage src={backgroundImage} />}

                  {blogStore.isLoaded && (
                    <StyledParagraph dangerouslySetInnerHTML={{
                      __html: limitArticleChars(
                        content.value,
                        BLOG_SETTINGS.ARTICLE_CHARS_LIMIT,
                      ),
                    }}
                    />
                  )}
                  {articleAuthor && (
                    <StyledParagraph>
                      {`${coreStore.translations.BLOG_BY} `}
                      {articleAuthor.name}
                    </StyledParagraph>
                  )}
                </Link>
              </LatestArticleWithFilter>
            </Fade>
          </Wrapper>
        </RelativeContainer>
        <RelativeImageBox>
          {!isOnMobile && (
            <FullWidthImage
              url={backgroundImage}
              innerRef={this.fullWidthImageRef}
            />
          )}
        </RelativeImageBox>
      </LatestArticleWrapper>
    );
  }
}
LatestArticle.propTypes = {
  article: PropTypes.instanceOf(BlogArticleModel).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default LatestArticle;



// WEBPACK FOOTER //
// ./src/pages/Blog/LatestArticle/index.jsx